<template>
  <v-container fluid>
    <v-row>
      <v-col cols="8">
        <label>Upload File</label>
        <div>
          <input type="file" @change="onFileChange" />
        </div>
      </v-col>
      <v-col cols="4" class="mt-5 pt-5">
        <v-btn
          :disabled="dataList.length == 0"
          class="form-btn"
          @click="onClick"
          >Upload
          <span></span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import readXlsxFile from "read-excel-file";
export default {
  data: () => ({
    dataList: [],
  }),
  methods: {
    onClick() {
      this.$store.dispatch("DataImport/importData", this.dataList);
    },
    excelDateToJSDate(excelDate) {
      if (typeof excelDate === "number") {
        var date = new Date(
          Math.round((excelDate - (25567 + 1)) * 86400 * 1000)
        );
        try {
          var converted_date = date.toISOString().split("T")[0];
          return converted_date;
        } catch (e) {
          return "2020-02-02";
        }
      } else {
        return excelDate;
      }
    },
    getTreatmentDate(date) {
      var d = new Date(this.excelDateToJSDate(date));
      d.setDate(d.getDate() - 1);
      return d;
    },
    manipulateColmn(row, titleRows) {
      let titles = [];
      let preEnrollInfoCount = 23;
      let enrollInfoCount = 128;
      let basicInfoCount = 28;
      titleRows.forEach((col) => {
        if (titles.length <= preEnrollInfoCount) titles.push(col);
      });
      let obj = {
        supports: [],
        preEnrollSupports: [],
      };
      titles.forEach((data, index) => {
        obj[data] = row[index];
      });
      row.forEach((col, index) => {
        if (index > basicInfoCount && index < enrollInfoCount) {
          if (index > basicInfoCount) {
            obj.supports.push(col);
          }
        } else if (index >= preEnrollInfoCount && index <= basicInfoCount) {
          obj.preEnrollSupports.push(col);
        }
      });
      obj[titleRows[129]] = row[129];
      obj[titleRows[138]] = row[138];
      obj["outside township"] = row[130];
      obj["outside township name"] = row[131];
      obj["dots status"] = row[132];
      obj["dots startdate"] = row[133];
      obj["dots enddate"] = row[134];

      obj["volunteer"] = row[135];
      obj[titleRows[136]] = row[136];
      obj[titleRows[137]] = row[137];
      obj[titleRows[138]] = row[138];
      obj[titleRows[139]] = row[139];
      obj[titleRows[140]] = row[140];
      obj[titleRows[141]] = row[141];

      /// pre enroll manipuldate
      let preEnrolls = [];
      if (obj.preEnrollSupports[0]) {
        preEnrolls.push({
          nomindated: obj.preEnrollSupports[0] === "Yes" ? 2 : 1,
          monthYear: obj.preEnrollSupports[1]
            ? this.excelDateToJSDate(obj.preEnrollSupports[1])
            : this.excelDateToJSDate(obj.preEnrollSupports[3]),
          month:
            new Date(
              obj.preEnrollSupports[1]
                ? this.excelDateToJSDate(obj.preEnrollSupports[1])
                : this.excelDateToJSDate(obj.preEnrollSupports[3])
            ).getMonth() + 1,
          year: new Date(
            obj.preEnrollSupports[1]
              ? this.excelDateToJSDate(obj.preEnrollSupports[1])
              : this.excelDateToJSDate(obj.preEnrollSupports[3])
          ).getFullYear(),
          support: obj.preEnrollSupports[2] === "Yes" ? 2 : 1,
          date: this.excelDateToJSDate(obj.preEnrollSupports[3]),
        });
        preEnrolls.push({
          nomindated: obj.preEnrollSupports[4] === "Yes" ? 2 : 1,
          monthYear: obj.preEnrollSupports[5]
            ? this.excelDateToJSDate(obj.preEnrollSupports[5])
            : this.excelDateToJSDate(obj.preEnrollSupports[7]),
          month:
            new Date(
              obj.preEnrollSupports[5]
                ? this.excelDateToJSDate(obj.preEnrollSupports[5])
                : this.excelDateToJSDate(obj.preEnrollSupports[7])
            ).getMonth() + 1,
          year: new Date(
            obj.preEnrollSupports[5]
              ? this.excelDateToJSDate(obj.preEnrollSupports[5])
              : this.excelDateToJSDate(obj.preEnrollSupports[7])
          ).getFullYear(),
          support: obj.preEnrollSupports[6] === "Yes" ? 2 : 1,
          date: this.excelDateToJSDate(obj.preEnrollSupports[7]),
        });
      }

      obj.preEnrollSupports = preEnrolls;

      /// pre enroll manipuldate

      // enroll manipulate

      let enrolls = [];
      for (var k = 0; k <= obj.supports.length; k += 2) {
        if (obj.supports[k]) {
          enrolls.push({
            received: obj.supports[k],
            date: this.excelDateToJSDate(obj.supports[k + 1]),
            month:
              new Date(this.excelDateToJSDate(obj.supports[k + 1])).getMonth() +
              1,
            year: new Date(
              this.excelDateToJSDate(obj.supports[k + 1])
            ).getFullYear(),
          });
        }
      }

      obj.supports = enrolls;

      // enroll manipulate

      // manipulate data
      var drtb = obj["DRTB no."]?.replace(" ", "");
      return {
        name: obj.Name,
        sex: obj.Sex === "M" ? 1 : 2,
        age: obj.Age,
        address: obj["Complete Address"] ?? '-',
        lab: obj["Lab result code"], // ask here for lab code (ans: xpertCode)
        townshipCode: obj["Township"],
        outside_tsp: obj["outside township"] === "Yes" ? 2 : 1,
        outside_tsp_name: obj["outside township name"],
        drtb: drtb,
        mdrtb_reg_no:
          drtb?.length >= 3
            ? drtb
              ? drtb.substring(0, drtb.indexOf("/"))
              : ""
            : "", // ask here about consistency
        mdrtb_reg_year:
          drtb?.length >= 3
            ? drtb
              ? drtb.substring(drtb.indexOf("/") + 1)
              : ""
            : "",
        type_of_patient: obj["Type of Patient"],
        type_of_tb: obj["Type of TB"]
          ? obj["Type of TB"] === "Pul TB"
            ? 1
            : 2
          : null,
        treatment_startdate: obj["Treatment Start Date"]
          ? this.getTreatmentDate(obj["Treatment Start Date"])
          : "",
        t_in: obj["Transfer in township"] ? 2 : 1,
        t_in_date: obj["Transfer in date"]
          ? new Date(obj["Transfer in date"])
          : "", /// ask about t_in type
        hiv_status: obj["HIV Testing"] === "yes" ? 2 : 1,
        // ask about hiv date
        hiv_result: this.getHivResult(obj["HIV Status"]), // question for R,NR,UN =Pos,Neg,Unk
        art_rx: obj["ART"] === "yes" ? 2 : 1, // ask about art date
        cpt_rx: obj["CPT"] === "yes" ? 2 : 1, // ask about cpt date
        treatment_finish: obj["Treatment finished date"] ? 2 : null, // ask about finish, stop and on-going,
        finished_date: obj["Treatment finished date"] ?? null,
        final_outcome: this.getOutcome(obj["Outcome"]),
        final_outcome_date: obj["Final Outcome\nDate"],
        // ask about gene date
        gene_result: this.getGeneResult(obj["Gene X pert result"]),
        gene_date: obj["Date of Result"],
        remark: obj["Remark"],
        regimen: obj["Regimen"],
        pre_enroll: obj.preEnrollSupports.length > 0 ? 1 : 0,
        pre_enrolls: obj.preEnrollSupports,
        supports: obj.supports,
        isDots: obj["isDots"] === "Yes" ? 2 : 1,
        dots_startdate: obj["dots startdate"]
          ? new Date(obj["dots startdate"])
          : "",
        dots_enddate: obj["dots enddate"] ? new Date(obj["dots enddate"]) : "",
      };
      // mainpuldate data
    },
    getHivResult(status) {
      switch (status) {
        case "Pos":
          return 1;

        case "Neg":
          return 2;

        case "Unk":
          return 3;
      }
    },
    getGeneResult(status) {
      switch (status) {
        case "N":
          return 1;

        case "T":
          return 2;

        case "RR":
          return 3;

        case "TI":
          return 4;

        case "I":
          return 5;
      }
    },
    getOutcome(status) {
      const finalOpt = [
        { value: 1, text: "Cured" },
        { value: 2, text: "Completed" },
        { value: 3, text: "Died" },
        { value: 4, text: "Lost to follow up" },
        { value: 5, text: "Failed" },
        { value: 6, text: "Moved to XDR" },
        { value: 7, text: "Not evaluated/ Transfer out" },
        { value: 8, text: "Moved to resident township" },
        { value: null, text: " " },
      ];
      let result = 0;
      finalOpt.forEach((e) => {
        if (e.text === status) result = e.value;
      });
      return result;
    },

    onFileChange(event) {
      let xlsxfile = event.target.files ? event.target.files[0] : null;

      let data = [];

      readXlsxFile(xlsxfile, { dateFormat: "mm/dd/yyyy" }).then((rows) => {
        let counter = 0;
        rows.forEach((row) => {
          if (counter >= 3) {
            data.push(this.manipulateColmn(row, rows[0]));
          }
          counter++;
        });
        this.dataList = data;
        console.log(this.dataList);
      });
    },
  },
};
</script>

<style></style>
